import { render, staticRenderFns } from "./PopupSetPassword.vue?vue&type=template&id=f47e0264&scoped=true&"
import script from "./PopupSetPassword.vue?vue&type=script&lang=ts&"
export * from "./PopupSetPassword.vue?vue&type=script&lang=ts&"
import style0 from "./PopupSetPassword.vue?vue&type=style&index=0&id=f47e0264&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47e0264",
  null
  
)

export default component.exports